// extracted by mini-css-extract-plugin
export var actions = "_qk-4";
export var item = "_qk-1";
export var price = "_qk-3";
export var quantity = "_qk-2";
export var table = "_qk-0";